export default __webpack_public_path__ + "static/media/level-5-bg.2f224cac.png";